import AddStreamingPlatformsPanel from './AddStreamingPlatformsPanel';

export default AddStreamingPlatformsPanel;
